import * as AppConstants from 'app/AppConstants';
import {loadById} from 'state/card/cardActions';
import {selectCardById} from 'state/card/cardSelectors';
import {
  selectDateGrainByCardId,
  selectDateRangeFilterByCardId,
  selectFilterGroupsByCardId,
} from 'state/cardFilter/cardFilterSelectors';
import {downloadBlob} from 'utilities/URL';
import {selectChartStateByChartURN} from 'state/chart/chartSelectors';
import {fetchCardExport} from 'state/card/cardService';
import {selectIsFeatureEnabled} from 'state/feature/featureSelectors';
import {FEATURE_SWITCHES} from 'components/FeatureSwitch';

const MIME_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  PPT: 'application/vnd.ms-powerpoint',
  CSV: 'text/csv',
};

const FILENAME_EXTENSIONS = {
  [MIME_TYPES.EXCEL]: 'xlsx',
  [MIME_TYPES.PPT]: 'pps',
  [MIME_TYPES.CSV]: 'csv',
};

const downloadCard = (cardId, blob, filenameExtension) => (
  dispatch,
  getState
) =>
  dispatch(loadById(cardId)).then(() => {
    const card = selectCardById(getState(), cardId);
    downloadBlob(blob, card.title + '.' + filenameExtension);
  });

const downloadExport = accept => (cardId, filters) => (dispatch, getState) => {
  const state = getState();
  const filenameExtension = FILENAME_EXTENSIONS[accept];
  dispatch({type: AppConstants.CARD__EXPORT_DOWNLOAD_STARTED});
  return fetchCardExport(cardId, {
    accept,
    fileName: cardId,
    type: 'file',
    chartState: selectChartStateByChartURN(state, cardId),
    dateTimeElement: selectDateGrainByCardId(state, cardId),
    dateRangeFilter: selectDateRangeFilterByCardId(state, cardId.replace(/^dr:([0-9]+:)/g, '')),//date range filters are set on the main card, not the drill card.
    filters,
    dataControlContext: {
      filterGroupIds: selectFilterGroupsByCardId(state, cardId),
    },
    isAddFilterTypeEnabled: selectIsFeatureEnabled(
      state,
      FEATURE_SWITCHES.ADD_FILTER_TYPE
    ),
  })
    .then(blob => dispatch(downloadCard(cardId, blob, filenameExtension)))
    .then(
      () => dispatch({type: AppConstants.CARD__EXPORT_DOWNLOAD_FINISHED}),
      () => dispatch({type: AppConstants.CARD__EXPORT_DOWNLOAD_FAILED})
    );
};

export const downloadCardCsv = downloadExport(MIME_TYPES.CSV);
export const downloadCardExcel = downloadExport(MIME_TYPES.EXCEL);
export const downloadCardPowerpoint = downloadExport(MIME_TYPES.PPT);
